module.exports = __webpack_public_path__ + "static/clients-desktop-9fb48cb15a645e880c13376d63843fb5.svg";